<template>
  <section id="footer">
    <div class="footer-content">
      <div class="footer-content-left">
        <h3>Menu</h3>
        <div class="menu-items">
          <a href="#intro">Home</a>
          <a href="#about">About</a>
          <a href="#work">Work</a>
          <a href="#projects">Projects</a>
        </div>
      </div>
      <div class="footer-content-right">
        <h3>Contact</h3>
        <a href="mailto:xander.janse.xj@gmail.com">xander.janse.xj@gmail.com</a>
      </div>
    </div>
    <div v-if="this.$themeName == 'christmas'" class="line line-kerst">
      <svg
        class="footer-img"
        width="400"
        height="311"
        viewBox="0 0 400 311"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="undraw_snow_fun_re_plbr 1" clip-path="url(#clip0_212_4375)">
          <path
            id="Vector"
            d="M286.871 309.879H253.233V283.881H178.794C178.424 283.881 178.061 283.783 177.741 283.599C177.421 283.414 177.155 283.148 176.971 282.828C176.786 282.508 176.689 282.145 176.689 281.775C176.689 281.406 176.786 281.043 176.971 280.723L202.007 237.359L202.428 237.559L202.354 237.757C204.583 238.566 223.442 245.215 249.214 248.615C259.064 249.923 268.988 250.589 278.924 250.608C303.699 250.608 326.016 246.283 345.256 237.754L345.449 237.669L370.306 280.723C370.491 281.043 370.588 281.406 370.588 281.775C370.588 282.145 370.49 282.508 370.306 282.828C370.121 283.148 369.855 283.414 369.535 283.599C369.215 283.783 368.852 283.881 368.483 283.881H286.871V309.879Z"
            fill="#9AD9A5"
          />
          <path
            id="Vector_2"
            d="M276.547 106.089C264.278 106.021 252.069 104.355 240.23 101.135L239.945 101.05L244.692 93.7631H229.813C229.443 93.7631 229.08 93.6658 228.76 93.481C228.44 93.2963 228.174 93.0305 227.989 92.7105C227.805 92.3904 227.707 92.0274 227.707 91.6579C227.707 91.2883 227.805 90.9253 227.989 90.6052L248.684 54.7616L249.092 54.9903L248.995 55.1689C256.704 58.829 265.128 60.7352 273.662 60.7505C281.561 60.7792 289.352 58.9233 296.39 55.3368L296.193 54.0208C272.642 66.0929 249.96 54.2661 249.004 53.7549L248.79 53.6411L273.638 11.5391L319.287 90.6052C319.472 90.9253 319.569 91.2883 319.569 91.6579C319.569 92.0274 319.472 92.3904 319.287 92.7105C319.103 93.0305 318.837 93.2963 318.517 93.481C318.197 93.6658 317.834 93.7631 317.464 93.7631H302.584L307.322 101.034L307.064 101.132C297.174 104.849 286.45 106.089 276.547 106.089Z"
            fill="#9AD9A5"
          />
          <path
            id="Vector_3"
            d="M278.913 249.245C269.007 249.228 259.112 248.564 249.293 247.259C222.65 243.746 203.172 237.603 202.356 237.303L202.095 237.207L214.744 215.299H202.952C202.582 215.299 202.219 215.201 201.899 215.016C201.579 214.832 201.313 214.566 201.128 214.246C200.944 213.926 200.846 213.563 200.846 213.193C200.846 212.824 200.944 212.461 201.128 212.141L233.466 156.129H212.331C211.961 156.129 211.598 156.032 211.278 155.847C210.958 155.662 210.692 155.396 210.508 155.076C210.323 154.756 210.225 154.393 210.225 154.024C210.225 153.654 210.323 153.291 210.508 152.971L214.98 145.225L215.391 145.447L215.297 145.633C216.972 146.44 228.563 151.78 247.344 154.536C254.972 155.64 262.671 156.188 270.378 156.176C290.487 156.176 310.962 152.624 331.242 145.618L331.102 145.213C295.564 157.489 266.004 155.9 247.449 153.182C227.567 150.271 215.796 144.469 215.304 144.223L215.082 144.112L239.884 102.053L240.228 102.509C252.055 105.735 264.254 107.401 276.513 107.464C287.995 107.464 298.271 105.803 307.058 102.525L306.966 102.28L307.388 102.081L336.769 152.971C336.954 153.291 337.051 153.654 337.051 154.024C337.051 154.393 336.954 154.756 336.769 155.076C336.584 155.396 336.318 155.662 335.998 155.847C335.678 156.032 335.315 156.129 334.946 156.129H313.81L333.43 189.177L333.164 189.27C301.406 200.434 271.158 199.806 251.375 197.313C231.148 194.764 217.36 190.735 215.481 190.034L215.325 190.433C217.203 191.135 230.996 196.109 251.292 198.67C259.297 199.677 267.356 200.183 275.423 200.186C295.825 200.186 315.353 196.946 333.467 190.557L333.65 190.492L346.149 212.141C346.333 212.461 346.431 212.824 346.431 213.193C346.431 213.563 346.333 213.926 346.149 214.246C345.964 214.566 345.698 214.832 345.378 215.016C345.058 215.201 344.695 215.298 344.325 215.298H332.532L345.233 236.36L344.994 236.465C322.945 246.22 299.504 249.245 278.913 249.245Z"
            fill="#9AD9A5"
          />
          <path
            id="Vector_4"
            d="M323.162 173.02C327.707 173.02 331.392 169.336 331.392 164.79C331.392 160.244 327.707 156.56 323.162 156.56C318.616 156.56 314.931 160.244 314.931 164.79C314.931 169.336 318.616 173.02 323.162 173.02Z"
            fill="#E6E6E6"
          />
          <path
            id="Vector_5"
            d="M317.725 164.526L315.593 161.225L316.026 160.945L317.859 163.785L321.622 160.989L324.987 164.306L328.295 161.429L331.328 164.916L330.94 165.254L328.244 162.155L324.965 165.007L321.575 161.665L317.725 164.526Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_6"
            d="M330.166 169.305L327.448 166.181L324.167 169.034L320.779 165.694L316.934 168.551L314.822 165.279L315.199 165.036L317.051 167.906L320.82 165.105L324.187 168.424L327.492 165.548L330.504 169.011L330.166 169.305Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_7"
            d="M323.632 150.642L323.203 156.8L323.716 156.836L324.145 150.678L323.632 150.642Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_8"
            d="M213.339 176.607C217.885 176.607 221.57 172.922 221.57 168.377C221.57 163.831 217.885 160.146 213.339 160.146C208.794 160.146 205.109 163.831 205.109 168.377C205.109 172.922 208.794 176.607 213.339 176.607Z"
            fill="#E6E6E6"
          />
          <path
            id="Vector_9"
            d="M207.902 168.112L205.771 164.811L206.203 164.531L208.036 167.371L211.799 164.575L215.164 167.892L218.472 165.015L221.505 168.502L221.117 168.84L218.421 165.741L215.142 168.593L211.752 165.251L207.902 168.112Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_10"
            d="M220.343 172.891L217.626 169.767L214.344 172.62L210.956 169.28L207.112 172.137L205 168.865L205.376 168.622L207.228 171.492L210.997 168.691L214.364 172.01L217.67 169.134L220.681 172.597L220.343 172.891Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_11"
            d="M213.808 154.228L213.379 160.386L213.893 160.421L214.322 154.264L213.808 154.228Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_12"
            d="M265.337 87.4032C269.882 87.4032 273.567 83.7183 273.567 79.1728C273.567 74.6273 269.882 70.9424 265.337 70.9424C260.791 70.9424 257.106 74.6273 257.106 79.1728C257.106 83.7183 260.791 87.4032 265.337 87.4032Z"
            fill="#E6E6E6"
          />
          <path
            id="Vector_13"
            d="M259.899 78.9119L257.768 75.6099L258.201 75.3311L260.034 78.1708L263.797 75.375L267.162 78.6915L270.47 75.8143L273.503 79.3021L273.115 79.6394L270.419 76.5399L267.14 79.3919L263.75 76.0501L259.899 78.9119Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_14"
            d="M272.341 83.6865L269.623 80.5623L266.342 83.4151L262.954 80.0757L259.109 82.9323L256.997 79.6603L257.374 79.417L259.226 82.2867L262.995 79.4862L266.362 82.8051L269.667 79.9297L272.679 83.3922L272.341 83.6865Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_15"
            d="M265.807 65.0247L265.378 71.1826L265.891 71.2184L266.32 65.0605L265.807 65.0247Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_16"
            d="M315.542 234.432C320.087 234.432 323.772 230.747 323.772 226.201C323.772 221.656 320.087 217.971 315.542 217.971C310.996 217.971 307.311 221.656 307.311 226.201C307.311 230.747 310.996 234.432 315.542 234.432Z"
            fill="#E6E6E6"
          />
          <path
            id="Vector_17"
            d="M310.104 225.94L307.973 222.639L308.406 222.359L310.239 225.2L314.001 222.403L317.367 225.72L320.674 222.843L323.708 226.33L323.319 226.668L320.624 223.569L317.345 226.421L313.955 223.079L310.104 225.94Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_18"
            d="M322.546 230.714L319.828 227.59L316.547 230.443L313.158 227.104L309.314 229.961L307.202 226.688L307.578 226.445L309.431 229.315L313.2 226.515L316.566 229.833L319.872 226.958L322.884 230.42L322.546 230.714Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_19"
            d="M316.011 212.053L315.582 218.211L316.096 218.247L316.525 212.089L316.011 212.053Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_20"
            d="M222.752 264.912C227.298 264.912 230.983 261.227 230.983 256.682C230.983 252.136 227.298 248.451 222.752 248.451C218.207 248.451 214.522 252.136 214.522 256.682C214.522 261.227 218.207 264.912 222.752 264.912Z"
            fill="#E6E6E6"
          />
          <path
            id="Vector_21"
            d="M217.315 256.42L215.184 253.118L215.616 252.839L217.449 255.679L221.213 252.883L224.577 256.2L227.885 253.323L230.918 256.81L230.531 257.148L227.835 254.048L224.556 256.9L221.165 253.558L217.315 256.42Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_22"
            d="M229.756 261.197L227.039 258.073L223.758 260.926L220.369 257.586L216.525 260.443L214.413 257.171L214.79 256.928L216.641 259.797L220.41 256.997L223.777 260.315L227.083 257.44L230.094 260.902L229.756 261.197Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_23"
            d="M223.222 242.535L222.793 248.693L223.306 248.729L223.735 242.571L223.222 242.535Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_24"
            d="M288.198 135.367C292.743 135.367 296.428 131.682 296.428 127.137C296.428 122.591 292.743 118.906 288.198 118.906C283.652 118.906 279.967 122.591 279.967 127.137C279.967 131.682 283.652 135.367 288.198 135.367Z"
            fill="#E6E6E6"
          />
          <path
            id="Vector_25"
            d="M282.761 126.875L280.629 123.573L281.062 123.294L282.895 126.134L286.658 123.337L290.023 126.654L293.331 123.777L296.364 127.265L295.976 127.602L293.28 124.503L290.001 127.355L286.611 124.013L282.761 126.875Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_26"
            d="M295.202 131.649L292.484 128.525L289.203 131.378L285.815 128.038L281.97 130.895L279.858 127.623L280.235 127.38L282.087 130.25L285.856 127.449L289.222 130.768L292.528 127.892L295.54 131.355L295.202 131.649Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_27"
            d="M288.668 112.989L288.239 119.146L288.752 119.182L289.181 113.024L288.668 112.989Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_28"
            d="M264.889 216.502C269.434 216.502 273.119 212.817 273.119 208.271C273.119 203.726 269.434 200.041 264.889 200.041C260.343 200.041 256.658 203.726 256.658 208.271C256.658 212.817 260.343 216.502 264.889 216.502Z"
            fill="#E6E6E6"
          />
          <path
            id="Vector_29"
            d="M259.451 208.009L257.32 204.707L257.753 204.428L259.586 207.268L263.349 204.472L266.713 207.789L270.022 204.911L273.055 208.399L272.667 208.737L269.971 205.637L266.692 208.489L263.302 205.147L259.451 208.009Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_30"
            d="M271.892 212.785L269.175 209.66L265.894 212.514L262.505 209.174L258.661 212.031L256.549 208.758L256.926 208.516L258.778 211.385L262.546 208.585L265.913 211.903L269.219 209.028L272.231 212.49L271.892 212.785Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_31"
            d="M265.358 194.123L264.929 200.281L265.443 200.317L265.872 194.159L265.358 194.123Z"
            fill="#CCCCCC"
          />
          <path
            id="Vector_32"
            d="M278.372 18.7672C278.118 18.7663 277.872 18.6826 277.67 18.5289L273.508 15.4055C273.389 15.3164 273.246 15.2671 273.097 15.2649C272.949 15.2626 272.804 15.3075 272.683 15.393L268.426 18.3864C268.224 18.5284 267.982 18.6028 267.735 18.599C267.488 18.5952 267.249 18.5133 267.051 18.3651C266.854 18.2168 266.708 18.0099 266.635 17.7739C266.563 17.5379 266.566 17.2849 266.646 17.0512L268.331 12.127C268.379 11.9868 268.382 11.8349 268.338 11.6932C268.294 11.5515 268.207 11.4273 268.088 11.3385L263.926 8.21508C263.728 8.06683 263.582 7.85985 263.51 7.62379C263.437 7.38772 263.441 7.1347 263.521 6.90099C263.601 6.66728 263.753 6.46487 263.955 6.32279C264.157 6.1807 264.399 6.10623 264.646 6.11004L269.849 6.19046C269.997 6.19301 270.143 6.14844 270.264 6.06317C270.385 5.9779 270.476 5.85634 270.524 5.716L272.208 0.79184C272.284 0.555246 272.434 0.349821 272.637 0.206966C272.84 0.064111 273.085 -0.0083152 273.333 0.000759782C273.581 0.00191118 273.821 0.0828321 274.019 0.231533C274.217 0.380235 274.362 0.588802 274.433 0.826326L275.964 5.80006C276.008 5.94182 276.095 6.06615 276.213 6.15512C276.332 6.24409 276.476 6.2931 276.624 6.29508L281.828 6.37549C282.075 6.37931 282.314 6.46122 282.512 6.60948C282.709 6.75774 282.855 6.96474 282.927 7.2008C283 7.43687 282.996 7.68988 282.916 7.92359C282.836 8.15729 282.684 8.35968 282.482 8.50176L278.225 11.495C278.104 11.5801 278.013 11.7015 277.965 11.8418C277.917 11.982 277.914 12.1339 277.958 12.2755L279.49 17.2495C279.565 17.4854 279.563 17.7393 279.483 17.9737C279.403 18.208 279.249 18.4102 279.045 18.5504C278.848 18.6905 278.613 18.7662 278.372 18.7672V18.7672Z"
            fill="#CCCCCC"
          />
          <g id="slee">
            <path
              id="Vector_33"
              d="M129.67 252.277L120.359 251.345C119.002 251.207 117.755 250.537 116.892 249.481C116.029 248.424 115.62 247.069 115.756 245.711C115.892 244.354 116.562 243.106 117.617 242.242C118.673 241.378 120.028 240.969 121.385 241.103L130.695 242.036C131.708 242.137 132.668 242.537 133.454 243.184C134.24 243.831 134.816 244.697 135.11 245.671C135.403 246.645 135.402 247.685 135.105 248.659C134.807 249.632 134.228 250.496 133.441 251.14C133.209 251.33 132.961 251.5 132.7 251.647C131.779 252.165 130.72 252.385 129.67 252.277V252.277Z"
              fill="#CCCCCC"
            />
            <path
              id="Vector_34"
              d="M138.13 293.398H130.41C129.834 293.397 129.265 293.278 128.737 293.049C128.208 292.82 127.732 292.486 127.338 292.066C126.942 291.646 126.637 291.149 126.442 290.605C126.248 290.062 126.169 289.484 126.209 288.908C126.3 287.825 126.798 286.817 127.603 286.088C128.408 285.358 129.46 284.961 130.547 284.977H132.282V275.62H142.574V288.953C142.573 290.132 142.104 291.261 141.271 292.095C140.438 292.928 139.308 293.397 138.13 293.398V293.398Z"
              fill="#CCCCCC"
            />
            <path
              id="Vector_35"
              d="M106.209 244.755C106.274 244.113 106.464 243.49 106.769 242.922C107.074 242.353 107.488 241.85 107.987 241.442C108.487 241.034 109.061 240.728 109.679 240.541C110.297 240.355 110.945 240.292 111.587 240.357L112.122 240.322L111.296 239.522C111.186 239.415 111.098 239.288 111.037 239.147C110.976 239.006 110.943 238.854 110.94 238.701C110.938 238.547 110.966 238.395 111.022 238.252C111.079 238.109 111.163 237.979 111.27 237.868C111.377 237.758 111.504 237.67 111.645 237.609C111.786 237.548 111.938 237.515 112.091 237.513C112.245 237.51 112.397 237.538 112.54 237.595C112.683 237.651 112.813 237.735 112.924 237.842L115.273 240.119L118.828 239.889C119.081 239.873 119.334 239.908 119.573 239.993C119.812 240.077 120.031 240.209 120.217 240.381C120.403 240.553 120.553 240.76 120.656 240.992C120.76 241.223 120.815 241.473 120.82 241.726L120.96 250.138C120.964 250.422 120.904 250.704 120.784 250.961C120.664 251.218 120.487 251.445 120.266 251.624C120.045 251.803 119.786 251.929 119.509 251.993C119.232 252.056 118.945 252.056 118.668 251.993L110.607 250.132C109.311 250.002 108.119 249.363 107.295 248.354C106.47 247.346 106.079 246.051 106.209 244.755V244.755Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_36"
              d="M143.51 282.404C154.232 282.404 162.925 271.931 162.925 259.012C162.925 246.093 154.232 235.62 143.51 235.62C132.787 235.62 124.094 246.093 124.094 259.012C124.094 271.931 132.787 282.404 143.51 282.404Z"
              fill="#E6E6E6"
            />
            <path
              id="Vector_37"
              d="M132.516 259.012C133.291 259.012 133.919 257.944 133.919 256.626C133.919 255.308 133.291 254.24 132.516 254.24C131.74 254.24 131.112 255.308 131.112 256.626C131.112 257.944 131.74 259.012 132.516 259.012Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_38"
              d="M132.048 265.655C132.823 265.655 133.451 264.587 133.451 263.269C133.451 261.951 132.823 260.883 132.048 260.883C131.273 260.883 130.644 261.951 130.644 263.269C130.644 264.587 131.273 265.655 132.048 265.655Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_39"
              d="M143.276 240.767C151.544 240.767 158.247 234.064 158.247 225.796C158.247 217.528 151.544 210.825 143.276 210.825C135.008 210.825 128.305 217.528 128.305 225.796C128.305 234.064 135.008 240.767 143.276 240.767Z"
              fill="#E6E6E6"
            />
            <path
              id="Vector_40"
              d="M155.907 221.35H131.112C130.306 221.35 129.533 221.029 128.963 220.459C128.393 219.889 128.072 219.116 128.071 218.31V215.97C128.071 208.091 136.048 200.766 144.679 200.766C153.311 200.766 158.48 208.091 158.48 215.97V218.777C158.48 219.46 158.208 220.114 157.726 220.596C157.244 221.078 156.59 221.35 155.907 221.35V221.35Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_41"
              d="M153.522 248.419L152.866 257.753C152.77 259.115 152.137 260.382 151.107 261.277C150.076 262.172 148.732 262.621 147.371 262.525C146.697 262.478 146.038 262.298 145.434 261.996C144.829 261.695 144.29 261.277 143.846 260.766C142.951 259.736 142.502 258.392 142.598 257.031L143.255 247.697C143.326 246.682 143.697 245.71 144.321 244.906C144.944 244.101 145.793 243.5 146.758 243.177C147.723 242.855 148.763 242.826 149.745 243.094C150.726 243.362 151.607 243.915 152.274 244.684C152.471 244.91 152.648 245.153 152.802 245.409C153.348 246.314 153.599 247.366 153.522 248.419V248.419Z"
              fill="#CCCCCC"
            />
            <path
              id="Vector_42"
              d="M146.697 272.093C146.054 272.047 145.426 271.876 144.848 271.588C144.271 271.3 143.756 270.901 143.333 270.414C142.91 269.927 142.587 269.361 142.383 268.749C142.179 268.137 142.097 267.491 142.142 266.848L142.092 266.314L141.316 267.163C141.213 267.277 141.088 267.369 140.949 267.435C140.81 267.5 140.659 267.538 140.505 267.545C140.352 267.552 140.198 267.529 140.053 267.476C139.909 267.424 139.776 267.344 139.662 267.24C139.549 267.136 139.457 267.011 139.392 266.872C139.326 266.733 139.289 266.582 139.283 266.428C139.276 266.275 139.299 266.121 139.352 265.976C139.405 265.832 139.485 265.699 139.589 265.586L141.795 263.17L141.461 259.623C141.437 259.371 141.465 259.117 141.542 258.876C141.619 258.634 141.745 258.412 141.911 258.22C142.077 258.029 142.28 257.874 142.508 257.763C142.736 257.653 142.984 257.59 143.237 257.578L151.642 257.19C151.926 257.176 152.209 257.228 152.47 257.341C152.731 257.453 152.962 257.624 153.148 257.839C153.333 258.055 153.466 258.31 153.539 258.584C153.611 258.859 153.619 259.147 153.563 259.425L151.942 267.537C151.851 268.837 151.247 270.047 150.263 270.901C149.28 271.756 147.997 272.184 146.697 272.093V272.093Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_43"
              d="M145.147 204.743C147.214 204.743 148.89 203.068 148.89 201.001C148.89 198.933 147.214 197.258 145.147 197.258C143.08 197.258 141.404 198.933 141.404 201.001C141.404 203.068 143.08 204.743 145.147 204.743Z"
              fill="#C80E48"
            />
            <path
              id="Vector_44"
              d="M139.767 226.029C140.542 226.029 141.171 225.4 141.171 224.625C141.171 223.85 140.542 223.222 139.767 223.222C138.992 223.222 138.364 223.85 138.364 224.625C138.364 225.4 138.992 226.029 139.767 226.029Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_45"
              d="M131.814 226.029C132.589 226.029 133.217 225.4 133.217 224.625C133.217 223.85 132.589 223.222 131.814 223.222C131.039 223.222 130.41 223.85 130.41 224.625C130.41 225.4 131.039 226.029 131.814 226.029Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_46"
              d="M155.206 293.398H147.486C146.308 293.397 145.178 292.928 144.345 292.095C143.512 291.261 143.043 290.132 143.042 288.953V275.62H153.334V284.977H155.069C156.156 284.961 157.208 285.358 158.013 286.088C158.818 286.817 159.316 287.825 159.407 288.908C159.447 289.484 159.368 290.062 159.174 290.605C158.979 291.149 158.674 291.646 158.278 292.066C157.884 292.486 157.408 292.82 156.879 293.049C156.351 293.278 155.781 293.397 155.206 293.398V293.398Z"
              fill="#CCCCCC"
            />
            <path
              id="Vector_47"
              d="M87.0794 256.505L80.8905 249.488C79.9877 248.464 79.5286 247.124 79.614 245.762C79.6995 244.399 80.3226 243.127 81.3463 242.224C82.3699 241.321 83.7103 240.862 85.0725 240.948C86.4347 241.033 87.7072 241.656 88.61 242.68L94.7988 249.697C95.472 250.461 95.9037 251.407 96.0394 252.415C96.175 253.424 96.0085 254.45 95.5608 255.365C95.1132 256.279 94.4045 257.04 93.5245 257.551C92.6444 258.062 91.6325 258.301 90.6167 258.237C90.3175 258.219 90.0205 258.174 89.729 258.105C88.7017 257.858 87.776 257.299 87.0794 256.505V256.505Z"
              fill="#CCCCCC"
            />
            <path
              id="Vector_48"
              d="M75.0031 235.03V235.03C75.4869 234.603 76.05 234.276 76.6603 234.067C77.2706 233.858 77.9161 233.771 78.5599 233.811C79.2037 233.852 79.8333 234.018 80.4126 234.302C80.992 234.586 81.5098 234.981 81.9364 235.465L82.3519 235.803L82.2911 234.655C82.2829 234.502 82.3051 234.348 82.3562 234.204C82.4074 234.059 82.4866 233.925 82.5893 233.811C82.692 233.697 82.8162 233.604 82.9548 233.538C83.0934 233.472 83.2436 233.434 83.397 233.425C83.5503 233.417 83.7038 233.439 83.8486 233.491C83.9934 233.542 84.1267 233.621 84.2409 233.724C84.3551 233.826 84.4479 233.951 84.5141 234.089C84.5803 234.228 84.6186 234.378 84.6267 234.531L84.8 237.798L87.5614 240.049C87.7577 240.209 87.9196 240.407 88.037 240.631C88.1545 240.856 88.2252 241.102 88.2449 241.354C88.2646 241.607 88.2328 241.861 88.1514 242.1C88.0701 242.34 87.9409 242.561 87.7717 242.75L82.1511 249.01C81.9613 249.222 81.7258 249.387 81.4625 249.494C81.1992 249.601 80.9151 249.646 80.6316 249.627C80.3481 249.608 80.0727 249.524 79.8264 249.383C79.58 249.241 79.3691 249.045 79.2097 248.81L74.5678 241.963C73.7061 240.986 73.2679 239.706 73.3495 238.406C73.4311 237.106 74.026 235.891 75.0031 235.03V235.03Z"
              fill="#C80E48"
            />
            <path
              id="Vector_49"
              d="M91.2713 287.231C94.1301 285.728 94.5959 280.987 92.3118 276.642C90.0276 272.297 85.8584 269.992 82.9995 271.495C80.1407 272.998 79.6749 277.739 81.959 282.084C84.2432 286.429 88.4124 288.734 91.2713 287.231Z"
              fill="#CCCCCC"
            />
            <path
              id="Vector_50"
              d="M103.042 288.719C113.765 288.719 122.457 278.246 122.457 265.327C122.457 252.408 113.765 241.936 103.042 241.936C92.3191 241.936 83.6266 252.408 83.6266 265.327C83.6266 278.246 92.3191 288.719 103.042 288.719Z"
              fill="#E6E6E6"
            />
            <path
              id="Vector_51"
              d="M97.9564 288.8C100.876 287.418 101.539 282.701 99.4385 278.264C97.3379 273.827 93.2687 271.35 90.3495 272.732C87.4304 274.114 86.7668 278.831 88.8674 283.268C90.968 287.706 95.0373 290.182 97.9564 288.8Z"
              fill="#CCCCCC"
            />
            <path
              id="Vector_52"
              d="M85.9658 264.392C86.741 264.392 87.3694 263.324 87.3694 262.006C87.3694 260.688 86.741 259.62 85.9658 259.62C85.1907 259.62 84.5623 260.688 84.5623 262.006C84.5623 263.324 85.1907 264.392 85.9658 264.392Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_53"
              d="M88.7231 256.296C89.071 255.025 88.747 253.829 87.9994 253.625C87.2517 253.42 86.3636 254.284 86.0157 255.555C85.6677 256.826 85.9917 258.022 86.7394 258.227C87.487 258.432 88.3751 257.567 88.7231 256.296Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_54"
              d="M85.9658 270.567C86.741 270.567 87.3694 269.499 87.3694 268.181C87.3694 266.863 86.741 265.795 85.9658 265.795C85.1907 265.795 84.5623 266.863 84.5623 268.181C84.5623 269.499 85.1907 270.567 85.9658 270.567Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_55"
              d="M102.808 247.082C111.076 247.082 117.779 240.38 117.779 232.111C117.779 223.843 111.076 217.141 102.808 217.141C94.5398 217.141 87.8372 223.843 87.8372 232.111C87.8372 240.38 94.5398 247.082 102.808 247.082Z"
              fill="#E6E6E6"
            />
            <path
              id="Vector_56"
              d="M115.44 227.667H90.6442C89.838 227.666 89.065 227.345 88.4949 226.775C87.9249 226.205 87.6042 225.432 87.6033 224.626V222.287C87.6033 214.407 94.1766 198.661 102.808 198.661C111.439 198.661 118.013 214.407 118.013 222.287V225.094C118.012 225.776 117.74 226.43 117.258 226.913C116.776 227.395 116.122 227.666 115.44 227.667V227.667Z"
              fill="#C80E48"
            />
            <path
              id="Vector_57"
              d="M111.829 260.944C111.53 260.944 111.231 260.918 110.935 260.866C109.932 260.692 109.004 260.223 108.267 259.521C107.531 258.819 107.019 257.914 106.796 256.92C106.574 255.927 106.651 254.89 107.018 253.941C107.385 252.991 108.025 252.172 108.858 251.587L116.512 246.204C117.628 245.419 119.011 245.11 120.355 245.344C121.7 245.578 122.897 246.337 123.682 247.454C124.467 248.57 124.776 249.953 124.542 251.297C124.308 252.642 123.549 253.838 122.432 254.624L114.779 260.006C113.916 260.616 112.886 260.944 111.829 260.944Z"
              fill="#CCCCCC"
            />
            <path
              id="Vector_58"
              d="M131.526 241.938V241.938C131.155 241.411 130.684 240.961 130.139 240.616C129.594 240.27 128.987 240.035 128.351 239.925C127.716 239.814 127.065 239.829 126.435 239.97C125.805 240.111 125.21 240.375 124.682 240.746L124.199 240.978L124.526 239.876C124.57 239.729 124.584 239.574 124.569 239.421C124.553 239.268 124.507 239.12 124.434 238.985C124.361 238.849 124.261 238.73 124.142 238.633C124.022 238.536 123.885 238.464 123.738 238.42C123.59 238.377 123.436 238.362 123.283 238.379C123.13 238.395 122.982 238.441 122.846 238.514C122.711 238.588 122.592 238.687 122.496 238.807C122.399 238.926 122.327 239.064 122.283 239.211L121.354 242.348L118.144 243.893C117.916 244.003 117.712 244.158 117.546 244.349C117.379 244.54 117.253 244.762 117.175 245.003C117.097 245.244 117.069 245.499 117.092 245.751C117.115 246.003 117.19 246.248 117.31 246.471L121.317 253.869C121.453 254.118 121.643 254.334 121.874 254.499C122.105 254.665 122.371 254.775 122.651 254.823C122.931 254.87 123.219 254.853 123.491 254.772C123.764 254.692 124.015 254.551 124.224 254.359L130.334 248.782C131.4 248.033 132.124 246.891 132.347 245.607C132.571 244.324 132.276 243.004 131.526 241.938V241.938Z"
              fill="#C80E48"
            />
            <path
              id="Vector_59"
              d="M101.872 202.17C103.939 202.17 105.615 200.494 105.615 198.427C105.615 196.36 103.939 194.685 101.872 194.685C99.8052 194.685 98.1296 196.36 98.1296 198.427C98.1296 200.494 99.8052 202.17 101.872 202.17Z"
              fill="#C80E48"
            />
            <path
              id="Vector_60"
              d="M94.8547 232.112C95.6298 232.112 96.2582 231.483 96.2582 230.708C96.2582 229.933 95.6298 229.305 94.8547 229.305C94.0796 229.305 93.4512 229.933 93.4512 230.708C93.4512 231.483 94.0796 232.112 94.8547 232.112Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_61"
              d="M89.7085 232.112C90.4837 232.112 91.112 231.483 91.112 230.708C91.112 229.933 90.4837 229.305 89.7085 229.305C88.9334 229.305 88.305 229.933 88.305 230.708C88.305 231.483 88.9334 232.112 89.7085 232.112Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_62"
              d="M136.652 230.208C136.639 230.208 136.625 230.208 136.612 230.208L123.702 229.643C123.554 229.652 123.407 229.609 123.286 229.522C123.166 229.434 123.081 229.307 123.044 229.162C123.008 228.894 123.22 228.658 123.56 228.588L135.903 226.048C136.096 226.008 136.296 226.033 136.473 226.119C136.549 226.153 136.617 226.205 136.67 226.269C136.724 226.334 136.761 226.411 136.78 226.492L137.347 229.597C137.359 229.679 137.35 229.764 137.318 229.841C137.287 229.918 137.235 229.985 137.168 230.035C137.021 230.151 136.839 230.212 136.652 230.208V230.208Z"
              fill="#FF6584"
            />
            <path
              id="Vector_63"
              d="M137.025 231.7C135.09 231.7 133.276 230.468 133.276 231.5C133.276 232.531 135.09 235.434 137.025 235.434C138.959 235.434 140.703 233.398 140.703 232.367C140.703 231.335 138.959 231.7 137.025 231.7Z"
              fill="white"
            />
            <path
              id="Vector_64"
              d="M93.9837 238.249C92.0492 238.249 90.2353 237.018 90.2353 238.049C90.2353 239.081 92.0491 241.984 93.9837 241.984C95.9183 241.984 97.6617 239.948 97.6617 238.916C97.6617 237.885 95.9183 238.249 93.9837 238.249Z"
              fill="white"
            />
            <path
              id="Vector_65"
              d="M93.0069 236.525C92.9954 236.525 92.9839 236.525 92.9723 236.524L81.8574 235.991C81.7244 235.995 81.5943 235.952 81.4905 235.869C81.3866 235.786 81.3159 235.668 81.2909 235.537C81.282 235.408 81.323 235.279 81.4055 235.179C81.488 235.078 81.6058 235.012 81.7349 234.996L92.3621 232.598C92.5283 232.56 92.7025 232.584 92.8525 232.664C92.9204 232.699 92.9795 232.749 93.0254 232.81C93.0713 232.871 93.1027 232.942 93.1174 233.017L93.6049 235.948C93.6165 236.024 93.6085 236.102 93.5815 236.175C93.5546 236.247 93.5097 236.311 93.451 236.362C93.3283 236.469 93.1701 236.527 93.0069 236.525Z"
              fill="#FF6584"
            />
            <path
              id="Vector_66"
              d="M223.978 309.772H38.0126C32.7411 309.766 27.6873 307.669 23.9598 303.942C20.2323 300.214 18.1355 295.16 18.1296 289.889C18.1296 289.269 18.376 288.674 18.8147 288.235C19.2534 287.796 19.8484 287.55 20.4687 287.55C21.0891 287.55 21.6841 287.796 22.1228 288.235C22.5615 288.674 22.8079 289.269 22.8079 289.889C22.8125 293.92 24.4159 297.785 27.2663 300.635C30.1168 303.486 33.9815 305.089 38.0126 305.094H223.978C224.598 305.094 225.193 305.34 225.632 305.779C226.07 306.217 226.317 306.812 226.317 307.433C226.317 308.053 226.07 308.648 225.632 309.087C225.193 309.526 224.598 309.772 223.978 309.772Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_67"
              d="M205.498 288.252H50.1764C49.2458 288.252 48.3533 288.622 47.6953 289.28C47.0373 289.938 46.6676 290.83 46.6676 291.761C46.6676 292.691 47.0373 293.584 47.6953 294.242C48.3533 294.9 49.2458 295.269 50.1764 295.269H65.3811V303.691C65.3811 304.807 65.8247 305.878 66.6143 306.668C67.4039 307.457 68.4749 307.901 69.5916 307.901C70.7083 307.901 71.7793 307.457 72.5689 306.668C73.3585 305.878 73.8021 304.807 73.8021 303.691V295.269H122.925V303.691C122.925 304.807 123.369 305.878 124.158 306.668C124.948 307.457 126.019 307.901 127.135 307.901C128.252 307.901 129.323 307.457 130.113 306.668C130.902 305.878 131.346 304.807 131.346 303.691V295.269H180.469V303.691C180.469 304.807 180.912 305.878 181.702 306.668C182.492 307.457 183.563 307.901 184.679 307.901C185.796 307.901 186.867 307.457 187.657 306.668C188.446 305.878 188.89 304.807 188.89 303.691V295.269H205.498C206.429 295.269 207.321 294.9 207.979 294.242C208.637 293.584 209.007 292.691 209.007 291.761C209.007 290.83 208.637 289.938 207.979 289.28C207.321 288.622 206.429 288.252 205.498 288.252Z"
              fill="#3F3D56"
            />
          </g>
          <path
            id="Vector_68"
            d="M399.532 310.24H0.467836C0.343758 310.24 0.224762 310.191 0.137026 310.103C0.0492894 310.016 0 309.897 0 309.773C0 309.648 0.0492894 309.529 0.137026 309.442C0.224762 309.354 0.343758 309.305 0.467836 309.305H399.532C399.656 309.305 399.775 309.354 399.863 309.442C399.951 309.529 400 309.648 400 309.773C400 309.897 399.951 310.016 399.863 310.103C399.775 310.191 399.656 310.24 399.532 310.24Z"
            fill="#CCCCCC"
          />
        </g>
        <defs>
          <clipPath id="clip0_212_4375">
            <rect width="400" height="310.241" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div v-if="this.$themeName == 'halloween'" class="line line-halloween">
      <svg
        class="footer-img"
        width="400"
        height="322"
        viewBox="0 0 400 322"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="undraw_spooky_self_gn-9-s 1" clip-path="url(#clip0_212_2111)">
          <path
            id="Vector"
            d="M5.63146 139.04C8.74082 139.04 11.2614 136.518 11.2614 133.406C11.2614 130.295 8.74082 127.772 5.63146 127.772C2.5221 127.772 0.00146484 130.295 0.00146484 133.406C0.00146484 136.518 2.5221 139.04 5.63146 139.04Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_2"
            d="M45.2833 173.48C48.3927 173.48 50.9133 170.957 50.9133 167.846C50.9133 164.734 48.3927 162.212 45.2833 162.212C42.174 162.212 39.6533 164.734 39.6533 167.846C39.6533 170.957 42.174 173.48 45.2833 173.48Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_3"
            d="M23.3031 169.389C26.4124 169.389 28.9331 166.866 28.9331 163.755C28.9331 160.643 26.4124 158.121 23.3031 158.121C20.1937 158.121 17.6731 160.643 17.6731 163.755C17.6731 166.866 20.1937 169.389 23.3031 169.389Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_4"
            d="M53.6163 237.766C53.4653 237.65 49.8753 234.834 46.2051 227.535C42.8381 220.838 38.7827 208.928 38.5854 190.217C38.2118 154.769 14.4297 135.188 14.1892 134.994L14.7331 134.319C14.794 134.368 20.9012 139.344 26.9607 148.675C34.9846 161.05 39.3175 175.457 39.4517 190.207C39.8247 225.594 54.0016 236.968 54.1448 237.079L53.6163 237.766Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_5"
            d="M30.9972 148.329C34.1065 148.329 36.6272 145.807 36.6272 142.695C36.6272 139.584 34.1065 137.062 30.9972 137.062C27.8878 137.062 25.3672 139.584 25.3672 142.695C25.3672 145.807 27.8878 148.329 30.9972 148.329Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_6"
            d="M31.308 195.094C34.4173 195.094 36.938 192.571 36.938 189.46C36.938 186.349 34.4173 183.826 31.308 183.826C28.1986 183.826 25.678 186.349 25.678 189.46C25.678 192.571 28.1986 195.094 31.308 195.094Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_7"
            d="M56.8658 236.74C56.8658 236.74 46.6435 225.812 58.687 210.045L56.8658 236.74Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_8"
            d="M50.3116 238.988C50.3116 238.988 42.6383 226.139 24.1692 233.369L50.3116 238.988Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_9"
            d="M5.63146 139.04C8.74082 139.04 11.2614 136.518 11.2614 133.406C11.2614 130.295 8.74082 127.772 5.63146 127.772C2.5221 127.772 0.00146484 130.295 0.00146484 133.406C0.00146484 136.518 2.5221 139.04 5.63146 139.04Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_10"
            d="M45.2833 173.48C48.3927 173.48 50.9133 170.957 50.9133 167.846C50.9133 164.734 48.3927 162.212 45.2833 162.212C42.174 162.212 39.6533 164.734 39.6533 167.846C39.6533 170.957 42.174 173.48 45.2833 173.48Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_11"
            d="M23.3031 169.389C26.4124 169.389 28.9331 166.866 28.9331 163.755C28.9331 160.643 26.4124 158.121 23.3031 158.121C20.1937 158.121 17.6731 160.643 17.6731 163.755C17.6731 166.866 20.1937 169.389 23.3031 169.389Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_12"
            d="M53.6163 237.766C53.4653 237.65 49.8753 234.834 46.2051 227.535C42.8381 220.838 38.7827 208.928 38.5854 190.217C38.2118 154.769 14.4297 135.188 14.1892 134.994L14.7331 134.319C14.794 134.368 20.9012 139.344 26.9607 148.675C34.9846 161.05 39.3175 175.457 39.4517 190.207C39.8247 225.594 54.0016 236.968 54.1448 237.079L53.6163 237.766Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_13"
            d="M30.9972 148.329C34.1065 148.329 36.6272 145.807 36.6272 142.695C36.6272 139.584 34.1065 137.062 30.9972 137.062C27.8878 137.062 25.3672 139.584 25.3672 142.695C25.3672 145.807 27.8878 148.329 30.9972 148.329Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_14"
            d="M31.308 195.094C34.4173 195.094 36.938 192.571 36.938 189.46C36.938 186.349 34.4173 183.826 31.308 183.826C28.1986 183.826 25.678 186.349 25.678 189.46C25.678 192.571 28.1986 195.094 31.308 195.094Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_15"
            d="M56.8658 236.74C56.8658 236.74 46.6435 225.812 58.687 210.045L56.8658 236.74Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_16"
            d="M50.3116 238.988C50.3116 238.988 42.6383 226.139 24.1692 233.369L50.3116 238.988Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_17"
            d="M64.6362 234.269H60.3054L61.6047 226.901H64.6362V234.269Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_18"
            d="M62.9665 277.696C77.0437 277.696 88.4555 267.841 88.4555 255.685C88.4555 243.529 77.0437 233.674 62.9665 233.674C48.8893 233.674 37.4775 243.529 37.4775 255.685C37.4775 267.841 48.8893 277.696 62.9665 277.696Z"
            fill="#F65C26"
          />
          <path
            id="Vector_19"
            opacity="0.1"
            d="M46.0254 272.545C41.7153 254.04 47.4403 237.941 47.4986 237.78L48.3124 238.076C48.2553 238.235 42.6196 254.103 46.8691 272.348L46.0254 272.545Z"
            fill="black"
          />
          <path
            id="Vector_20"
            opacity="0.1"
            d="M77.3263 274.265L76.5227 273.941C84.7431 253.526 76.6238 237.628 76.5409 237.47L77.3081 237.067C77.3927 237.229 85.6947 253.483 77.3263 274.265Z"
            fill="black"
          />
          <path
            id="Vector_21"
            opacity="0.1"
            d="M55.1687 276.981C44.763 260.948 55.0041 234.734 55.109 234.471L55.9134 234.791C55.8107 235.05 45.7345 260.854 55.8952 276.508L55.1687 276.981Z"
            fill="black"
          />
          <path
            id="Vector_22"
            opacity="0.1"
            d="M70.7646 276.981L70.038 276.508C80.2026 260.848 70.1225 235.05 70.0198 234.791L70.8242 234.471C70.9291 234.734 81.1702 260.948 70.7646 276.981Z"
            fill="black"
          />
          <path
            id="Vector_23"
            opacity="0.1"
            d="M53.1597 242.35L56.2995 247.791L59.4393 253.233H53.1597H46.8801L50.0199 247.791L53.1597 242.35Z"
            fill="black"
          />
          <path
            id="Vector_24"
            d="M53.1597 243.507L55.6321 247.792L58.1046 252.077H53.1597H48.2148L50.6873 247.792L53.1597 243.507Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_25"
            opacity="0.1"
            d="M63.5535 260.14L61.9295 257.325L60.3054 254.511H63.5535H66.8016L65.1775 257.325L63.5535 260.14Z"
            fill="black"
          />
          <path
            id="Vector_26"
            d="M63.5536 259.543L62.2747 257.326L60.9958 255.109H63.5536H66.1114L64.8325 257.326L63.5536 259.543Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_27"
            opacity="0.1"
            d="M73.0811 242.35L76.2209 247.791L79.3607 253.233H73.0811H66.8015L69.9413 247.791L73.0811 242.35Z"
            fill="black"
          />
          <path
            id="Vector_28"
            d="M73.0811 243.507L75.5535 247.792L78.026 252.077H73.0811H68.1362L70.6087 247.792L73.0811 243.507Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_29"
            opacity="0.1"
            d="M73.731 261.981H52.9434V266.361H73.731V261.981Z"
            fill="black"
          />
          <path
            id="Vector_30"
            d="M71.5655 262.438H55.1086V265.904H71.5655V262.438Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_31"
            d="M58.7897 264.703L57.5108 262.487L56.2319 260.271H58.7897H61.3474L60.0686 262.487L58.7897 264.703Z"
            fill="#F65C26"
          />
          <path
            id="Vector_32"
            d="M67.4513 264.703L66.1724 262.487L64.8936 260.271H67.4513H70.0091L68.7302 262.487L67.4513 264.703Z"
            fill="#F65C26"
          />
          <path
            id="Vector_33"
            d="M201.559 121.222L192.887 88.2802L194.162 87.954C194.162 87.954 185.37 44.9618 180.652 42.6028C176.957 40.7555 175.252 41.4668 175.252 41.4668L157.806 42.4426C155.509 41.047 153.533 39.1819 152.007 36.9693C157.902 35.3994 163.336 32.7351 166.814 28.3197L165.575 24.8085C165.575 24.8085 167.742 24.9112 168.362 28.0094L169.6 26.15C169.6 26.15 167.432 23.3621 161.961 20.1619C158.37 18.0614 156.29 13.1129 155.285 9.95993C154.476 7.32097 152.889 4.98819 150.732 3.26754C146.93 0.306806 140.544 -2.37034 132.851 3.43845C132.851 3.43845 125.11 2.30449 122.533 13.5628C119.956 24.8212 115.005 37.6293 115.005 37.6293L119.34 37.8347C119.34 37.8347 118.925 30.3986 121.299 28.8487L122.127 38.3503C127.535 39.0035 132.989 39.1995 138.431 38.9362L138.112 45.687L119.417 54.1362C119.417 54.1362 117.854 53.7101 117.998 58.1176C118.141 62.5251 123.41 107.31 123.41 107.31L124.652 106.999L129.245 140.151C129.245 140.151 126.125 161.479 135.36 159.628C139.254 158.848 139.737 154.806 138.992 150.392C139.611 151.844 140.29 153.311 141.042 154.793C155.684 183.651 158.102 192.039 158.102 192.039L174.741 249.332C176.801 249.517 178.875 249.423 180.909 249.053L184.833 262.836C184.833 262.836 181.995 278.192 191.515 277.763C191.61 277.759 191.704 277.754 191.797 277.749C192.974 277.677 194.117 277.327 195.132 276.729C196.148 276.131 197.008 275.3 197.642 274.306C198.276 273.311 198.666 272.181 198.78 271.007C198.893 269.833 198.728 268.649 198.297 267.551L195.346 259.99C195.346 259.99 193.692 248.874 190.003 244.849C190.03 244.825 190.058 244.803 190.085 244.778L176.714 189.048L169.884 154.927L181.687 191.748L189.228 229.423C189.228 229.423 189.562 229.645 190.141 229.965C190.196 231.915 190.56 233.843 191.219 235.678C192.783 239.801 195.912 251.743 195.912 251.743C195.912 251.743 198.473 264.539 203.446 263.542C205.222 263.186 206.417 261.343 207.221 259.121C208.042 256.77 208.377 254.277 208.207 251.793C208.036 249.309 207.364 246.885 206.23 244.668L201.449 235.107L200.805 231.89C202.929 231.247 204.939 229.721 206.419 226.717L199.446 184.492C199.446 184.492 193.84 139.722 189.762 124.718C191.762 123.728 193.035 122.93 193.035 122.93L180.383 100.327C179.04 98.4142 177.91 96.3596 177.014 94.2003L177.007 94.2017C175.679 91.0372 174.561 86.9655 175.012 82.7939C175.197 80.9313 175.715 79.1172 176.541 77.4376C176.937 76.6166 177.261 75.7622 177.507 74.8843L180.807 91.3699L181.657 91.1526L195.592 120.939C195.592 120.939 194.177 143.404 203.412 141.553C212.647 139.702 201.559 121.222 201.559 121.222ZM138.648 90.0821C140.33 93.3532 139.713 97.5803 139.514 98.6552C139.482 98.8245 139.463 98.9169 139.463 98.9169C138.769 99.5838 138.176 100.348 137.701 101.185L134.611 85.7494C135.467 86.5412 136.379 87.3038 137.329 88.2541C137.86 88.792 138.305 89.4086 138.648 90.0821ZM136.265 104.09C136.19 104.268 136.117 104.448 136.044 104.631L136.065 104.14L136.265 104.09ZM134.643 137.591L134.699 136.281C134.857 137.132 135.036 137.992 135.234 138.862C134.875 138.061 134.643 137.591 134.643 137.591H134.643Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_34"
            d="M360.617 276.609H22.665V277.815H360.617V276.609Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_35"
            d="M198.89 22.7843H194.559L195.858 15.417H198.89V22.7843Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_36"
            d="M163.53 124.68L161.357 160.929C161.357 160.929 154.112 181.228 163.53 181.228C172.948 181.228 167.152 159.479 167.152 159.479L175.846 123.955L163.53 124.68Z"
            fill="#D35721"
          />
          <path
            id="Vector_37"
            d="M233.805 120.329L235.978 156.578C235.978 156.578 243.223 176.877 233.805 176.877C224.386 176.877 230.182 155.128 230.182 155.128L221.489 119.604L233.805 120.329Z"
            fill="#D35721"
          />
          <path
            id="Vector_38"
            d="M190.336 274.023L191.785 292.148C191.785 292.148 185.989 306.647 195.407 308.097C195.501 308.111 195.595 308.125 195.687 308.138C196.855 308.299 198.044 308.181 199.157 307.794C200.271 307.407 201.277 306.762 202.094 305.911C202.91 305.061 203.514 304.029 203.856 302.9C204.198 301.771 204.269 300.577 204.062 299.416L202.652 291.423C202.652 291.423 203.376 276.923 199.03 274.023C194.683 271.123 190.336 274.023 190.336 274.023Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_39"
            d="M204.101 258.074C204.101 258.074 202.652 262.424 203.376 266.774C204.101 271.124 204.825 283.448 204.825 283.448C204.825 283.448 204.825 296.498 209.897 296.498C211.708 296.498 213.242 294.926 214.466 292.905C215.732 290.761 216.55 288.382 216.871 285.913C217.191 283.444 217.007 280.935 216.33 278.539L213.519 268.224V260.249L204.101 258.074Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_40"
            d="M177.295 125.404C177.295 125.404 161.357 146.428 170.05 177.602C178.744 208.776 179.469 217.476 179.469 217.476L184.54 276.923C184.54 276.923 193.234 279.823 200.479 275.473L198.305 218.201V183.402L202.652 221.825V260.249C202.652 260.249 212.795 270.399 220.04 260.974L221.489 218.201C221.489 218.201 225.835 158.753 222.937 152.953C220.04 147.153 213.519 126.854 213.519 126.854L177.295 125.404Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_41"
            d="M197.22 66.2117C211.298 66.2117 222.709 56.357 222.709 44.2006C222.709 32.0442 211.298 22.1895 197.22 22.1895C183.143 22.1895 171.731 32.0442 171.731 44.2006C171.731 56.357 183.143 66.2117 197.22 66.2117Z"
            fill="#D35721"
          />
          <path
            id="Vector_42"
            d="M191.785 57.2568L187.438 74.6561L200.479 112.355L210.621 72.4812C210.621 72.4812 201.203 65.9565 203.377 57.2568H191.785Z"
            fill="#D35721"
          />
          <path
            id="Vector_43"
            d="M227.284 156.578C227.284 156.578 206.274 164.553 201.927 152.229C197.581 139.904 198.305 130.479 198.305 130.479C198.305 130.479 191.785 155.853 180.917 155.853C170.05 155.853 164.254 152.229 164.254 152.229C164.254 152.229 172.224 126.855 179.469 122.505C179.469 122.505 179.505 122.418 179.57 122.258C179.976 121.243 181.41 117.22 180.403 113.682C180.199 112.954 179.883 112.262 179.468 111.63C176.571 107.28 173.673 105.83 174.397 94.9559L168.601 74.6567L188.59 70.0459L199.029 102.931L208.535 70.7346L225.835 73.2068C225.835 73.2068 227.284 99.3057 220.039 108.73C218.9 110.215 218.037 111.892 217.489 113.682C216.229 117.684 216.526 121.896 217.207 125.26H217.214C217.669 127.553 218.373 129.79 219.315 131.929L227.284 156.578Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_44"
            d="M221.489 73.9313L225.835 73.2064C225.835 73.2064 227.647 72.8439 230.907 75.3813C235.07 78.6216 235.254 122.504 235.254 122.504L221.489 123.229V73.9313Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_45"
            d="M172.224 76.1066L168.601 74.6566C168.601 74.6566 167.152 73.9317 166.428 78.2815C165.703 82.6313 162.081 127.58 162.081 127.58L177.295 126.855V94.2309L172.224 76.1066Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_46"
            opacity="0.1"
            d="M180.279 61.0605C175.969 42.5555 181.694 26.4563 181.752 26.2959L182.566 26.5921C182.509 26.7502 176.873 42.6188 181.123 60.8637L180.279 61.0605Z"
            fill="black"
          />
          <path
            id="Vector_47"
            opacity="0.1"
            d="M211.58 62.7806L210.776 62.4569C218.997 42.0417 210.877 26.144 210.795 25.9859L211.562 25.583C211.646 25.7449 219.948 41.9982 211.58 62.7806Z"
            fill="black"
          />
          <path
            id="Vector_48"
            opacity="0.1"
            d="M189.422 65.4963C179.017 49.4638 189.258 23.2494 189.363 22.9863L190.167 23.3071C190.064 23.5659 179.988 49.3692 190.149 65.024L189.422 65.4963Z"
            fill="black"
          />
          <path
            id="Vector_49"
            opacity="0.1"
            d="M205.018 65.4963L204.292 65.024C214.456 49.3635 204.376 23.5659 204.273 23.3071L205.078 22.9863C205.183 23.2493 215.424 49.4637 205.018 65.4963Z"
            fill="black"
          />
          <path
            id="Vector_50"
            opacity="0.1"
            d="M187.413 30.8652L190.553 36.3071L193.693 41.7489H187.413H181.134L184.274 36.3071L187.413 30.8652Z"
            fill="black"
          />
          <path
            id="Vector_51"
            d="M187.413 32.0225L189.886 36.3076L192.358 40.5928H187.413H182.469L184.941 36.3076L187.413 32.0225Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_52"
            opacity="0.1"
            d="M197.807 48.6558L196.183 45.8411L194.559 43.0264H197.807H201.055L199.431 45.8411L197.807 48.6558Z"
            fill="black"
          />
          <path
            id="Vector_53"
            d="M197.807 48.0584L196.528 45.8417L195.25 43.625H197.807H200.365L199.086 45.8417L197.807 48.0584Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_54"
            opacity="0.1"
            d="M207.335 30.8652L210.475 36.3071L213.614 41.7489H207.335H201.055L204.195 36.3071L207.335 30.8652Z"
            fill="black"
          />
          <path
            id="Vector_55"
            d="M207.335 32.0225L209.807 36.3076L212.28 40.5928H207.335H202.39L204.863 36.3076L207.335 32.0225Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_56"
            opacity="0.1"
            d="M207.985 50.4971H187.197V54.8764H207.985V50.4971Z"
            fill="black"
          />
          <path
            id="Vector_57"
            d="M205.819 50.9531H189.362V54.4201H205.819V50.9531Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_58"
            d="M193.043 53.2191L191.764 51.0028L190.486 48.7861H193.043H195.601L194.322 51.0028L193.043 53.2191Z"
            fill="#D35721"
          />
          <path
            id="Vector_59"
            d="M201.705 53.2191L200.426 51.0028L199.147 48.7861H201.705H204.263L202.984 51.0028L201.705 53.2191Z"
            fill="#D35721"
          />
          <path
            id="Vector_60"
            d="M199.431 113.658H198.19L198.562 111.548H199.431V113.658Z"
            fill="#2F2E41"
          />
          <path
            id="Vector_61"
            d="M198.953 126.095C202.984 126.095 206.252 123.273 206.252 119.791C206.252 116.31 202.984 113.487 198.953 113.487C194.921 113.487 191.653 116.31 191.653 119.791C191.653 123.273 194.921 126.095 198.953 126.095Z"
            fill="#D35721"
          />
          <path
            id="Vector_62"
            opacity="0.1"
            d="M193.8 124.69C193.042 121.334 193.191 117.837 194.232 114.558L195.046 114.854C194.078 117.977 193.939 121.299 194.643 124.493L193.8 124.69Z"
            fill="black"
          />
          <path
            id="Vector_63"
            opacity="0.1"
            d="M203.352 125.228L202.548 124.904C204.842 119.208 202.589 114.762 202.567 114.718L203.334 114.315C203.436 114.51 205.801 119.144 203.352 125.228Z"
            fill="black"
          />
          <path
            id="Vector_64"
            opacity="0.1"
            d="M196.46 126.058C193.394 121.333 196.29 113.914 196.415 113.601L197.22 113.921C197.191 113.994 194.365 121.239 197.187 125.586L196.46 126.058Z"
            fill="black"
          />
          <path
            id="Vector_65"
            opacity="0.1"
            d="M201.445 126.058L200.718 125.586C203.543 121.233 200.714 113.994 200.685 113.921L201.49 113.601C201.614 113.914 204.511 121.333 201.445 126.058Z"
            fill="black"
          />
          <path
            id="Vector_66"
            d="M323.616 311.409H314.088V265.905C317.264 264.076 320.44 264.076 323.616 265.905V311.409Z"
            fill="#D0CDE1"
          />
          <path
            id="Vector_67"
            d="M365.191 310.976H275.977V311.842H365.191V310.976Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_68"
            d="M305.427 321.377H295.899V275.873C299.075 274.044 302.251 274.044 305.427 275.873V321.377Z"
            fill="#D0CDE1"
          />
          <path
            id="Vector_69"
            d="M301.529 267.205H299.797V276.306H301.529V267.205Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_70"
            d="M305.86 263.305C305.86 264.684 305.312 266.007 304.338 266.982C303.363 267.958 302.041 268.506 300.663 268.506C299.285 268.506 297.963 267.958 296.988 266.982C296.014 266.007 295.466 264.684 295.466 263.305C295.466 260.433 300.663 251.171 300.663 251.171C300.663 251.171 305.86 260.433 305.86 263.305Z"
            fill="#D35721"
          />
          <path
            id="Vector_71"
            d="M319.718 257.237H317.986V266.338H319.718V257.237Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_72"
            d="M324.049 253.337C324.049 254.717 323.502 256.039 322.527 257.015C321.552 257.99 320.231 258.538 318.852 258.538C317.474 258.538 316.152 257.99 315.177 257.015C314.203 256.039 313.655 254.717 313.655 253.337C313.655 250.465 318.852 241.203 318.852 241.203C318.852 241.203 324.049 250.465 324.049 253.337Z"
            fill="#D35721"
          />
          <path
            id="Vector_73"
            d="M341.805 321.377H332.278V275.873C335.453 274.044 338.629 274.044 341.805 275.873V321.377Z"
            fill="#D0CDE1"
          />
          <path
            id="Vector_74"
            d="M337.908 267.205H336.175V276.306H337.908V267.205Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_75"
            d="M342.238 263.305C342.238 264.684 341.691 266.007 340.716 266.982C339.742 267.958 338.42 268.506 337.041 268.506C335.663 268.506 334.341 267.958 333.367 266.982C332.392 266.007 331.844 264.684 331.844 263.305C331.844 260.433 337.041 251.171 337.041 251.171C337.041 251.171 342.238 260.433 342.238 263.305Z"
            fill="#D35721"
          />
          <path
            id="Vector_76"
            d="M365.191 320.942H275.977V321.809H365.191V320.942Z"
            fill="#3F3D56"
          />
          <path
            id="Vector_77"
            d="M96.2186 85.2511C96.3704 86.3049 96.3763 87.3746 96.2361 88.43C96.2073 88.6692 96.1707 88.9043 96.1283 89.1366L96.1286 89.1383C95.626 91.6353 94.6225 94.0043 93.1785 96.1019C93.0841 96.2379 93.0302 96.3088 93.0302 96.3088L92.8279 96.1543C91.2244 94.8728 89.8338 93.3452 88.7078 91.6284C88.6093 91.4727 88.5105 91.3153 88.4165 91.1536C87.5797 89.7867 87.0156 88.2705 86.7554 86.6889L86.752 86.666C86.7269 86.4976 86.7052 86.3287 86.6891 86.1607C86.5573 84.6829 86.6843 83.1933 87.0644 81.7592C87.1094 81.5803 87.1567 81.4047 87.2077 81.2303C87.7841 79.3024 88.6559 77.4757 89.7921 75.8153C89.8865 75.6792 89.9404 75.6084 89.9404 75.6084C89.9404 75.6084 90.0127 75.6604 90.1427 75.7629C91.701 77.0078 93.0585 78.4853 94.1677 80.1434C94.2651 80.292 94.3611 80.4427 94.4558 80.5971C95.1049 81.6423 95.6054 82.7729 95.9429 83.9563C96.0006 84.1628 96.0519 84.374 96.0961 84.5862C96.1449 84.8048 96.1851 85.0266 96.2186 85.2511Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_78"
            d="M271.729 82.9098C272.411 83.7272 272.977 84.6347 273.411 85.6067C273.512 85.8255 273.604 86.0448 273.69 86.2648L273.691 86.2661C274.572 88.6556 274.96 91.1992 274.831 93.743C274.822 93.9084 274.813 93.997 274.813 93.997L274.56 93.9717C272.523 93.7229 270.538 93.1527 268.679 92.2825C268.514 92.2017 268.347 92.1196 268.183 92.0313C266.753 91.3071 265.478 90.3126 264.427 89.1028L264.412 89.0852C264.303 88.9551 264.196 88.8226 264.094 88.6881C263.207 87.4993 262.534 86.1646 262.105 84.7442C262.05 84.5683 261.998 84.3939 261.95 84.2187C261.43 82.2749 261.214 80.2621 261.31 78.2521C261.319 78.0867 261.328 77.998 261.328 77.998C261.328 77.998 261.417 78.0043 261.581 78.0233C263.561 78.2648 265.491 78.8097 267.305 79.6388C267.465 79.7141 267.626 79.792 267.788 79.8737C268.888 80.4226 269.907 81.1222 270.815 81.9523C270.973 82.0979 271.127 82.2507 271.276 82.4081C271.432 82.5687 271.583 82.7359 271.729 82.9098Z"
            fill="#F2F2F2"
          />
          <path
            id="Vector_79"
            d="M297.726 159.463C297.382 160.47 296.9 161.426 296.296 162.302C296.161 162.501 296.022 162.694 295.878 162.882L295.878 162.883C294.295 164.878 292.324 166.53 290.084 167.741C289.938 167.819 289.858 167.857 289.858 167.857L289.748 167.628C288.903 165.756 288.359 163.763 288.138 161.721C288.121 161.538 288.104 161.353 288.094 161.166C287.971 159.568 288.158 157.961 288.645 156.434L288.653 156.412C288.707 156.251 288.764 156.09 288.826 155.933C289.381 154.557 290.172 153.289 291.162 152.185C291.284 152.046 291.406 151.911 291.53 151.779C292.92 150.325 294.527 149.095 296.294 148.134C296.44 148.056 296.52 148.018 296.52 148.018C296.52 148.018 296.561 148.097 296.63 148.247C297.452 150.065 297.989 151.999 298.222 153.981C298.241 154.157 298.258 154.335 298.272 154.516C298.375 155.742 298.307 156.977 298.069 158.184C298.027 158.395 297.976 158.606 297.919 158.815C297.863 159.032 297.798 159.248 297.726 159.463Z"
            fill="#F2F2F2"
          />
          <g id="spook">
            <path
              id="Vector_80"
              d="M377.514 83.8939C377.492 76.1171 374.394 68.6652 368.899 63.1662C363.403 57.6671 355.957 54.5677 348.185 54.5449C347.933 54.5449 347.682 54.5481 347.431 54.5546C327.595 55.062 315.109 76.2328 323.832 94.0683L341.342 129.874C341.345 130.911 341.758 131.905 342.49 132.638C343.223 133.371 344.216 133.784 345.252 133.787H354.051L357.636 123.026L366.322 133.787H378.166L381.751 123.026L390.437 133.787H396.089C397.126 133.784 398.119 133.371 398.851 132.638C399.584 131.905 399.997 130.911 400 129.874L377.514 83.8939Z"
              fill="#CFCCE0"
            />
            <path
              id="Vector_81"
              d="M333.846 83.5677C338.346 83.5677 341.993 79.9177 341.993 75.4152C341.993 70.9127 338.346 67.2627 333.846 67.2627C329.347 67.2627 325.699 70.9127 325.699 75.4152C325.699 79.9177 329.347 83.5677 333.846 83.5677Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_82"
              d="M355.68 83.5677C360.18 83.5677 363.827 79.9177 363.827 75.4152C363.827 70.9127 360.18 67.2627 355.68 67.2627C351.181 67.2627 347.533 70.9127 347.533 75.4152C347.533 79.9177 351.181 83.5677 355.68 83.5677Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_83"
              d="M333.846 78.3503C335.466 78.3503 336.779 77.0363 336.779 75.4154C336.779 73.7945 335.466 72.4805 333.846 72.4805C332.227 72.4805 330.914 73.7945 330.914 75.4154C330.914 77.0363 332.227 78.3503 333.846 78.3503Z"
              fill="#CFCCE0"
            />
            <path
              id="Vector_84"
              d="M355.68 78.3503C357.3 78.3503 358.613 77.0363 358.613 75.4154C358.613 73.7945 357.3 72.4805 355.68 72.4805C354.061 72.4805 352.748 73.7945 352.748 75.4154C352.748 77.0363 354.061 78.3503 355.68 78.3503Z"
              fill="#CFCCE0"
            />
            <path
              id="Vector_85"
              d="M336.78 71.8284C337.679 71.8284 338.409 71.0984 338.409 70.1979C338.409 69.2974 337.679 68.5674 336.78 68.5674C335.88 68.5674 335.15 69.2974 335.15 70.1979C335.15 71.0984 335.88 71.8284 336.78 71.8284Z"
              fill="#CFCCE0"
            />
            <path
              id="Vector_86"
              d="M358.613 71.8284C359.513 71.8284 360.243 71.0984 360.243 70.1979C360.243 69.2974 359.513 68.5674 358.613 68.5674C357.713 68.5674 356.984 69.2974 356.984 70.1979C356.984 71.0984 357.713 71.8284 358.613 71.8284Z"
              fill="#CFCCE0"
            />
            <path
              id="Vector_87"
              d="M344.133 98.2831C346.764 98.2831 348.897 96.1489 348.897 93.5161C348.897 90.8833 346.764 88.749 344.133 88.749C341.502 88.749 339.369 90.8833 339.369 93.5161C339.369 96.1489 341.502 98.2831 344.133 98.2831Z"
              fill="#3F3D56"
            />
            <path
              id="Vector_88"
              d="M365.312 65.1087L372.184 57.3035C373.305 56.0298 374.47 54.7227 376 53.9901C377.53 53.2575 379.536 53.2428 380.765 54.413C382.638 56.1972 381.308 59.8345 378.804 60.4819C376.3 61.1293 373.625 59.2655 372.748 56.831C372.238 55.2714 372.293 53.5818 372.905 52.0592C373.517 50.5366 374.645 49.2785 376.092 48.5061C379.775 46.6795 384.233 48.4964 388.278 47.7682C393.385 46.849 397.145 41.2697 396.084 36.1875"
              fill="#CFCCE0"
            />
            <path
              id="Vector_89"
              d="M333.348 63.3753L326.476 55.5701C325.355 54.2964 324.19 52.9893 322.66 52.2567C321.13 51.5241 319.124 51.5094 317.895 52.6796C316.021 54.4638 317.352 58.1011 319.856 58.7485C322.36 59.3959 325.035 57.5321 325.912 55.0977C326.422 53.5381 326.367 51.8484 325.755 50.3258C325.143 48.8032 324.015 47.5451 322.568 46.7727C318.885 44.9461 314.427 46.763 310.382 46.0348C305.275 45.1156 301.514 39.5363 302.576 34.4541"
              fill="#CFCCE0"
            />
          </g>
        </g>
        <defs>
          <clipPath id="clip0_212_2111">
            <rect width="400" height="321.809" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div v-if="this.$themeName == 'fall'" class="line line-fall">
      <img class="footer-img" src="/assets/fall/undraw_autumn_re_rwy0.svg" />
    </div>
    <div v-if="this.$themeName == 'default'" class="line"></div>
    <div class="footer-bottom">
      <p class="copyright">&copy;2021 - xanderjanse</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
#footer {
  background: #f5f5f5;
  height: 70vh;
  position: relative;
}

.footer-content {
  display: flex;
}

.footer-content-left {
  width: 50%;
}

.footer-content-right {
  width: 50%;
}

.line {
  position: absolute;
  bottom: 5rem;
  width: 80%;
  height: 1px;
  background: #63dde2;
}

.line-kerst {
  background: #c80e48;
}

.line-halloween {
  background: #d35721;
}

.line-fall {
  background: #dba72e;
}

.footer-bottom {
  position: absolute;
  height: 5rem;
  display: flex;
  align-items: center;
  bottom: 0;
  width: 100%;
}

.menu-items {
  display: flex;
  flex-direction: column;
}

/* Theme img */
.footer-img {
  position: absolute;
  bottom: 0;
  right: 0rem;
  width: 20rem;
}

#spook {
  animation: moveSpook 5s infinite;
}

@keyframes moveSpook {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(3rem);
  }
  100% {
    transform: translateX(0);
  }
}

/* #slee {
  animation: moveSled 5s infinite;
} */

@keyframes moveSled {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-10rem);
  }
  100% {
    transform: translateX(0);
  }
}

@media (max-width: 480px) {
  #footer {
    height: 50vh;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .footer-content {
    flex-direction: column;
  }

  .footer-content-left {
    margin-bottom: 2rem;
  }

  .footer-content-left,
  .footer-content-right {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .line {
    display: none;
  }
  .footer-bottom {
    left: 0;
    justify-content: center;
  }

  .footer-img {
    display: none;
  }
}
</style>
